import React, { useState } from 'react';
import './App.css';

function Careers() {
  const [showApply, setShowApply] = useState(false);

  const toggleApply = () => {
    setShowApply(!showApply);
  };

  return (
    <div className="careers-container">
      <h1>Careers at Horizon Seeds</h1>
      <div className="careers-content">
        <div className="vacancy-card">
          <h2>We're Always Interested in Great People</h2>
          <p>
            At Horizon Seeds, we're always keen to hear from talented and passionate individuals
            who are interested in working with us. Whether your strengths lie in operations,
            logistics, sales, or agriculture, we’d love to hear from you.
          </p>
          <p>
            If you're enthusiastic, driven, and want to be part of a dynamic team committed to
            excellence in the seed industry, send us your CV and let us know how you can contribute.
          </p>
          <button className="apply-button" onClick={toggleApply}>
            {showApply ? 'Hide Details' : 'Send Your CV'}
          </button>
          <div className={`apply-info ${showApply ? 'show' : ''}`}>
            <h3>Send Us Your CV</h3>
            <p><strong>Contact:</strong> Laura Witterick</p>
            <p><strong>Email:</strong> <a href="mailto:laurawitterick@cofcointernational.com">laurawitterick@cofcointernational.com</a></p>
            <p><strong>Phone:</strong> <a href="tel:+441473275062">+44 1473 275 062</a></p>
            <p><strong>HR Correspondence Address:</strong></p>
            <address>
              COFCO International UK Ltd<br />
              15 The Havens<br />
              Ipswich, Suffolk, IP3 9SJ<br />
              United Kingdom
            </address>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Careers;
